export const actionTypes = {
  REQUEST_START: 'MESSAGES.CAMERAL_AUDITS.REQUEST_START',
  GET_YEARS_START: 'MESSAGES.GET_YEARS.REQUEST_START',
  REQUEST_SUCCESS: 'MESSAGES.CAMERAL_AUDITS.REQUEST_SUCCESS',
  GET_YEARS_SUCCESS: 'MESSAGES.GET_YEARS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.CAMERAL_AUDITS.REQUEST_FAILURE',
  GET_YEARS_FAILURE: 'MESSAGES.GET_YEARS.REQUEST_FAILURE',
  GET_CAMERAL_FOR_DOCUMENT_ID_START: 'MESSAGES.GET_CAMERAL_FOR_DOCUMENT_ID_START',
  GET_CAMERAL_FOR_DOCUMENT_ID_FAILURE: 'MESSAGES.GET_CAMERAL_FOR_DOCUMENT_ID_FAILURE',
  GET_CAMERAL_FOR_DOCUMENT_ID_SUCCESS: 'MESSAGES.GET_CAMERAL_FOR_DOCUMENT_ID_SUCCESS',
};

export function startRequest(year) {
  return {
    type: actionTypes.REQUEST_START,
    payload: year,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function getYearsRequest() {
  return {
    type: actionTypes.GET_YEARS_START,
  };
}

export function getYearsSuccess(data) {
  return {
    type: actionTypes.GET_YEARS_SUCCESS,
    payload: data,
  };
}

export function getYearsFailure(error) {
  return {
    type: actionTypes.GET_YEARS_FAILURE,
    payload: error,
  };
}

export function getDataForDocumentIdRequest(cardId) {
  return {
    type: actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_START,
    payload: cardId,
  };
}

export function getDataForDocumentIdSuccess(data) {
  return {
    type: actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_SUCCESS,
    payload: data,
  };
}

export function getDataForDocumentIdFailure(error) {
  return {
    type: actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_FAILURE,
    payload: error,
  };
}
